import { ExternalLink, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/site/ui";

function ArticleLink({ article, featured, testid }) {
  const external = article.type === "external" && article.external_url;
  const href = external ? article.external_url : `/news/${article.id}`;
  const props = { href, target: "_blank", rel: "noopener noreferrer" };

  if (featured) {
    return (
      <a {...props} data-testid={testid} className="group grid md:grid-cols-2 overflow-hidden rounded-[2rem] bg-ink text-ivory">
        {article.image_url && <div className="aspect-[16/11] md:aspect-auto overflow-hidden"><img src={article.image_url} alt={article.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" /></div>}
        <div className="p-9 md:p-12 flex flex-col justify-center">
          <p className="label-eyebrow !text-champagne">{article.publication} · {article.date}</p>
          <h3 className="mt-4 font-heading text-3xl md:text-4xl leading-tight">{article.title}</h3>
          {article.excerpt && <p className="mt-5 font-body text-ivory/75 leading-relaxed">{article.excerpt}</p>}
          <span className="mt-7 inline-flex items-center gap-2 font-body text-sm uppercase tracking-wide text-blush">Read More {external ? <ExternalLink size={15} /> : <ArrowUpRight size={15} />}</span>
        </div>
      </a>
    );
  }
  return (
    <a {...props} data-testid={testid} className="group block h-full rounded-[1.5rem] overflow-hidden bg-ivory border border-champagne/30 hover:-translate-y-1 transition-transform">
      {article.image_url && <div className="aspect-[16/10] overflow-hidden"><img src={article.image_url} alt={article.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" /></div>}
      <div className="p-6">
        <p className="label-eyebrow">{article.publication}{article.date ? ` · ${article.date}` : ""}</p>
        <p className="mt-2 font-heading text-lg text-ink leading-snug group-hover:text-bronze transition-colors line-clamp-3">{article.title}</p>
        <span className="mt-4 inline-flex items-center gap-1 font-body text-xs uppercase tracking-wide text-bronze">Read More {external ? <ExternalLink size={13} /> : <ArrowUpRight size={13} />}</span>
      </div>
    </a>
  );
}

export function News({ news }) {
  const press = news.filter((n) => (n.section || "newsroom") === "newsroom");
  const featured = press.find((n) => n.featured) || press[0];
  const rest = press.filter((n) => n.id !== (featured && featured.id)).slice(0, 6);
  return (
    <section id="news" className="py-24 md:py-32 bg-gradient-to-b from-ivory to-blush/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <Reveal><Eyebrow>Featured In</Eyebrow></Reveal>
          <Reveal delay={0.05}><h2 className="mt-4 font-heading text-4xl md:text-6xl text-ink">In The News</h2></Reveal>
        </div>
        {featured && <Reveal><div className="mt-12"><ArticleLink article={featured} featured testid="featured-article" /></div></Reveal>}
        <div className="mt-6 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {rest.map((a, i) => (
            <Reveal key={a.id} delay={i * 0.06}><ArticleLink article={a} testid={`news-card-${a.id}`} /></Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
